import React, { FC, PropsWithChildren } from 'react';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import { useTranslation } from '../translations';
import { MaterialIcon } from '.';

import './InlineHelp.scss';

let inlineHelpId = 1;

export interface InlineHelpProps {
  readonly href?: string;
}

export const InlineHelp: FC<PropsWithChildren<InlineHelpProps>> = ({ href, children }) => {
  const { ts } = useTranslation();
  const key = `help-${inlineHelpId++}`;

  if (href) {
    return (
      <span className="inline-help">
        {' '}
        (
        <a href={href} rel="noreferrer" target="_blank">
          {children ?? ts('help')}
        </a>
        )
      </span>
    );
  }

  return (
    <>
      <span className="inline-icon" id={key}>
        <MaterialIcon name="info" small />
      </span>
      <UncontrolledPopover placement="bottom" target={key} trigger="hover">
        <PopoverBody>{children}</PopoverBody>
      </UncontrolledPopover>
    </>
  );
};
